import React from "react";
import styles from "./Tabs.module.css";

const list = ["overview", "papers", "risks", "lessons"]; // this is for workStream/overview.js
// use lowercase for the list of tabs because in the Tabs component, we capitalize the first letter of each tab.

function Tabs({ tab, setTab, tabContentList = list }) {

  return (
    <div className={styles.container}>
      <div className="d-flex">
        {tabContentList.map((tabContent) => (
          <button
            key={tabContent}
            className={`me-2 pt-2 pt-4 pb-sm-2 pb-3 px-1 px-sm-2 px-md-4 fw-semibold p4 ${
              styles.inactiveButton
            } ${tab === tabContent ? styles.activeButton : ""} `}
            onClick={() => setTab(tabContent)}
          >
            {tabContent.charAt(0).toUpperCase() + tabContent.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Tabs;
